/*
 *
 * */

import FilterFactory from '@/lib/filterFactory';

export default class CitiesFilter {
    filterHandlers = {
        update: 'citiesFilter/updateFilter',
        reset: 'citiesFilter/resetFilter',
        resetState: 'citiesFilter/resetFilterState',
        removeSelected: 'citiesFilter/removeSelectedFilter',
    };
    filterModel = {};

    constructor() {
        const filter = new FilterFactory();

        filter.createSearchEntity('name');
        filter.setPlaceholder('name', 'По названию');
        filter.setName('name', 'search_name');
        filter.setPreviewName('name', 'Название');
        filter.setClassName('name', 'col-1-row-1');
        filter.setIconClassName('name', 'icon-store');
        filter.setAction('name', 'citiesFilter/updateSearch');

        this.filterModel = filter.filterModel;
    }
}